import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';

import { FormGroup, Validators, FormBuilder } from '@angular/forms';

import { CustomValidators } from 'ng2-validation';

import { DropdownValue } from '../shared/dropdown.model';
import { DropdownComponent } from '../shared/dropdown.component';

import { FilterItemsService } from '../shared/filter-items.service';

import { CampaignPpa } from './campaign.model';

import { CampaignsService } from './campaigns.service';

import { FieldValidatorService } from '../shared/field-validator-service';
import { FormHelperService } from "../core/services/form-helper.service";
import { ObjectFactoryService } from '../core/services/object-factory.service';

@Component({
    selector: 'ppa-modal',
    moduleId: module.id,
    templateUrl: 'ppa-modal.component.html'
})
export class PpaComponent implements OnInit {
    ppaFrom: FormGroup;
    headerText: string = "Add Post Play Action";
    typeSelectionText: string;
    typeValues: Array<DropdownValue> = new Array<DropdownValue>();
    typePrefix: string = "Type";
    typeId: number = 0;
    typeName: string;
    ppaId: number;
    private campaignId: number;
    isLoading: boolean = true;

    @ViewChild("typeSelector") dropdownComponent: DropdownComponent;

    @Output()
    public ppaChanged: EventEmitter<CampaignPpa> = new EventEmitter<CampaignPpa>();

    @Output()
    public ppaCreated: EventEmitter<CampaignPpa> = new EventEmitter<CampaignPpa>();

    constructor(
        private filterItemsService: FilterItemsService,
        private formBuilder: FormBuilder,
        private campaignsService: CampaignsService,
        private fieldValidatorService: FieldValidatorService,
        private formHelperService: FormHelperService,
        private factoryService: ObjectFactoryService) {
    }

    ngOnInit() {
        this.ppaFrom = this.formBuilder.group({
            displayProbabilityField: ['', [Validators.required, this.fieldValidatorService.isHundredIntegerRange]],
            orderField: ['', [Validators.required, this.fieldValidatorService.isPositiveInteger]],
            clickThroughUrlField: ['', [CustomValidators.url]],
            isAvailableField: ['', []],
            facebookShareUrlField: ['', [CustomValidators.url]],
            twitterShareUrlField: ['', [CustomValidators.url]]
        });
    }

    onSaveChanges(event: any) {
        if (!this.ppaFrom.valid) { return; };

        let campaignPpa = this.factoryService.createPPA(this.ppaId, this.campaignId, this.typeId, this.typeName, this.ppaFrom.value.orderField,
            this.ppaFrom.value.displayProbabilityField, !this.ppaFrom.value.isAvailableField ? false : true,
            this.ppaFrom.value.clickThroughUrlField, this.ppaFrom.value.facebookShareUrlField, this.ppaFrom.value.twitterShareUrlField
        );

        if (this.ppaId === 0) {
            this.isLoading = true;
            let result = this.campaignsService.createPpa(campaignPpa).subscribe(response => {
                let campaignPpa = response.json();
                campaignPpa.ppaTypeName = this.typeName;
                this.ppaCreated.emit(campaignPpa);
                $('#ppaModal').modal('hide');
            }, () => { }, () => { this.isLoading = false; });
        }
        else {
            this.isLoading = true;
            let result = this.campaignsService.updatePpa(campaignPpa).subscribe(response => {
                let campaignPpa = response.json();
                campaignPpa.ppaTypeName = this.typeName;
                this.ppaChanged.emit(campaignPpa);
                $('#ppaModal').modal('hide');
            }, () => { }, () => { this.isLoading = false; });
        }
    }

    isClickThroughRequired(): boolean {
        let control = this.ppaFrom.get('clickThroughUrlField');
        return (this.typeId === 3 && !this.ppaFrom.value.clickThroughUrlField && control.touched);
    }

    onTypeValueChanged(item) {
        this.typeId = item.value;
        this.typeName = item.label;
        if(this.typeId != 1){
            this.ppaFrom.controls["facebookShareUrlField"].setValue("");
            this.ppaFrom.controls["twitterShareUrlField"].setValue("");
        }else
        {
            this.ppaFrom.controls["facebookShareUrlField"].setValue("http://");
            this.ppaFrom.controls["twitterShareUrlField"].setValue("http://");
        }
    }

    showCreatePpa(campaignId: number, typeValues: Array<DropdownValue>) {
        this.isLoading = false;
        this.typeValues = typeValues;
        this.headerText = "Add Post Play Action";
        this.ppaFrom.reset();

        this.ppaFrom.controls["clickThroughUrlField"].setValue("http://");
      
        setTimeout(() => {
            if (this.typeValues.length > 0) {
                this.dropdownComponent.setCurrentSelection(this.typeValues[0]);
                this.typeId = this.typeValues[0].value;
                this.typeName = this.typeValues[0].label;
                if(this.typeId != 1){
                    this.ppaFrom.controls["facebookShareUrlField"].setValue("");
                    this.ppaFrom.controls["twitterShareUrlField"].setValue("");
                }else
                {
                    this.ppaFrom.controls["facebookShareUrlField"].setValue("http://");
                    this.ppaFrom.controls["twitterShareUrlField"].setValue("http://");
                }
            }
        }, 0
        );

        this.ppaId = 0;
        this.campaignId = campaignId;

        $('#ppaModal').modal('show');
    }

    showEditPpa(event, item) {
        event.preventDefault();
        event.stopPropagation();
        this.headerText = "Edit Post Play Action";
        this.ppaFrom.controls["displayProbabilityField"].setValue(item.displayProbability);
        this.ppaFrom.controls["orderField"].setValue(item.order);
        this.ppaFrom.controls["isAvailableField"].setValue(item.isLive);
        this.ppaId = item.id;
        this.campaignId = item.campaignId;
        this.typeId = item.ppaType;
        this.typeSelectionText = item.ppaTypeName;

        this.isLoading = true;
        this.campaignsService.getPpaFields(this.ppaId).subscribe(respose => {
            let ppa = respose.json();
            this.ppaFrom.controls["clickThroughUrlField"].setValue(ppa.clickThroughUrl);
            this.ppaFrom.controls["facebookShareUrlField"].setValue(ppa.facebookShareUrl);
            this.ppaFrom.controls["twitterShareUrlField"].setValue(ppa.twitterShareUrl);
            $('#ppaModal').modal('show');
        }, () => { }, () => { this.isLoading = false; });
    }

    showErrorMessage(controlName: string, validator: string): boolean {
        return this.formHelperService.showErrorMessage(this.ppaFrom, controlName, validator)
    }
}


// WEBPACK FOOTER //
// ./src/app/campaigns/ppa-modal.component.ts